import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@core/config/routes'

export const accountsRoutes: RouteRecordRaw[] = [
  {
    path: routes.PROPERTY_OWNER_APPROVALS,
    name: 'PROPERTY_OWNER_APPROVALS',
    component: () => import('./pages/PropertyOwnerApprovalsPage.vue'),
    meta: { requiresAuth: true },
  },
  { path: routes.PROPERTY_OWNERS, redirect: routes.PROPERTY_OWNERS_ALL },
  {
    path: routes.PROPERTY_OWNERS_PIPELINE,
    name: 'PROPERTY_OWNERS_PIPELINE',
    component: () => import('./pages/PropertyOwnersPipelinePage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_ALL,
    name: 'PROPERTY_OWNERS_ALL',
    component: () => import('./pages/PropertyOwnersAllPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_REJECTED,
    name: 'PROPERTY_OWNERS_REJECTED',
    component: () => import('./pages/PropertyOwnersRejectedPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_BLOCKED,
    name: 'PROPERTY_OWNERS_BLOCKED',
    component: () => import('./pages/PropertyOwnersBlockedPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_DRAFT,
    name: 'PROPERTY_OWNERS_DRAFT',
    component: () => import('./pages/PropertyOwnersDraftPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_DRAFT_EDIT,
    name: 'PROPERTY_OWNERS_DRAFT_EDIT',
    component: () => import('./pages/PropertyOwnersDraftEditPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_CREATE,
    name: 'PROPERTY_OWNERS_CREATE',
    component: () => import('./pages/PropertyOwnersCreatePage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  // NOTE: the `/create` route is registered BEFORE the parameterless list
  // route so vue-router doesn't accidentally match the create path against a
  // future `/property-owners/bank-accounts/:id` detail route (if one lands).
  {
    path: routes.PROPERTY_OWNERS_BANK_ACCOUNT_CREATE,
    name: 'PROPERTY_OWNERS_BANK_ACCOUNT_CREATE',
    component: () => import('./pages/PropertyOwnersBankAccountCreatePage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  {
    path: routes.PROPERTY_OWNERS_BANK_ACCOUNTS,
    name: 'PROPERTY_OWNERS_BANK_ACCOUNTS',
    component: () => import('./pages/PropertyOwnersBankAccountsPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
  // Parameterised details route registered LAST so any future static path
  // under /property-owners/<verb> doesn't get swallowed by the :id matcher.
  {
    path: routes.PROPERTY_OWNER_DETAILS,
    name: 'PROPERTY_OWNER_DETAILS',
    component: () => import('./pages/PropertyOwnerDetailsPage.vue'),
    meta: { requiresAuth: true, activeMenu: 'Property Owners' },
  },
]
